import configService from './app-config.service';

const getSubjectList = async (authToken, locationId, locationType) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);

    const options = {
        method: 'GET',
        headers: headers
    };

    const response = await fetch(`${configService.appConfig.apiUrl}/regulation/Details/Location/${locationId}/LocationType/${locationType}/GetSubjectListLocation`, options);
    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

const getSubjectListWorldWide = async (authToken) => {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${authToken}`);
    const options = {
        method: 'GET',
        headers: headers
    };
    const response = await fetch(`${configService.appConfig.apiUrl}/regulation/Details/GetSubjectListWorldWide`, options);
    if (!response.ok) {
        const message = `An error occurred: ${response.statusText}`;
        console.error(message);
        return;
    }

    const jsonData = await response.json();
    return jsonData;
};

export default {
    getSubjectList,
    getSubjectListWorldWide
};
